





















































































































































































import { Component, Prop, Vue, Provide, Watch } from "vue-property-decorator";
import CategoryPathsViewer from "@/components/CategoryPathsViewer.vue";
import BulkCategorySelection from "@/components/BulkCategorySelection.vue";
import errorsUtil from "./../utils/errorMappings";
import _ from "lodash";

interface Profile {
  accountId: string;
  companyId: string;
  categories: string[];
  createdBy: string;
  createdAt: string;
  deletedAt: string;
  isDefault: boolean;
  profileId: string;
  profileName: string;
  updatedBy: string;
  updatedAt: string;
  isOutdated: boolean;
}

interface SelectOption {
  label: string;
  value: string;
  selected?: boolean;
}

@Component({
  components: { CategoryPathsViewer, BulkCategorySelection },
})
export default class BulkCategory extends Vue {
  @Provide("$api") $api: any;

  @Prop() private accountId!: string;
  @Prop() private companyId!: string;
  @Prop() private jobId!: string;

  private isCategoryOnlyView = false;
  private profiles: Profile[] = [];
  private profilesData: SelectOption[] = [];
  private selectedProfile = "";
  private categoryPaths: string[] = [];
  private loading = false;
  private createProfileForCategories = false;
  private profileName = "";
  private isProfileNameInvalid = false;

  private errorMessageTop = "";

  async mounted() {
    this.loading = true;
    this.$store.commit("startLoading");
    this.loadData();
  }

  private displayError(error) {
    const errorCode = error.response.data.code;
    if (_.has(errorsUtil.errorMessages, errorCode)) {
      this.$store.commit("recordError", "");
      this.errorMessageTop = errorsUtil.errorMessages[errorCode];
    }
  }

  async loadData() {
    this.$api
      .get(`item-classification-api/v1/jobs/${this.companyId}/${this.jobId}`)
      .then((response) => {
        this.$store.commit("startLoading");
        const jobDetails = response.data;
        this.loadProfiles(
          jobDetails.metadata.profileName,
          jobDetails.categories
        );
      })
      .catch((error) => {
        this.loading = false;
        this.$store.commit("stopLoading");
        this.displayError(error);
      });
  }

  async loadProfiles(metadataProfile: string, categories: string[]) {
    this.$api
      .get(`item-classification-api/v1/profiles/${this.companyId}`, {})
      .then((response) => {
        this.profiles = response.data.value;
        const defaultProfile: string =
          this.profiles.find((p) => p.isDefault)?.profileName || "";
        //new job
        if (metadataProfile === undefined) {
          this.isCategoryOnlyView = false;
          this.selectedProfile = defaultProfile;
          this.categoryPaths =
            this.profiles.find((p) => p.profileName === this.selectedProfile)
              ?.categories || [];
        }
        //update job and category only view
        else if (metadataProfile === "") {
          this.isCategoryOnlyView = true;
          this.selectedProfile = defaultProfile;
          this.categoryPaths = categories;
        }
        //update job and profile view
        else {
          this.isCategoryOnlyView = false;
          this.selectedProfile = this.profiles.some(
            (p) => p.profileName === metadataProfile
          )
            ? metadataProfile
            : defaultProfile;
          this.categoryPaths =
            this.profiles.find((p) => p.profileName === this.selectedProfile)
              ?.categories || [];
        }
        this.profilesData =
          this.profiles.map((p) => {
            return {
              label: p.isDefault ? `${p.profileName} (Default)` : p.profileName,
              value: p.profileName,
              selected: p.profileName === this.selectedProfile,
            };
          }) || [];
        this.loading = false;
        this.$store.commit("stopLoading");
      })
      .catch((error) => {
        this.loading = false;
        this.$store.commit("stopLoading");
        this.displayError(error);
      });
  }

  private onProfileSelected(e) {
    this.selectedProfile = e.detail.item.value;
    this.profilesData = this.profiles.map((p) => {
      return {
        label: p.isDefault ? `${p.profileName} (Default)` : p.profileName,
        value: p.profileName,
        selected: p.profileName === this.selectedProfile,
      };
    });
    this.categoryPaths =
      this.profiles.find((p) => p.profileName === this.selectedProfile)
        ?.categories || [];
  }

  private toProfilesView() {
    //selected profile and profiles data remain same as last one
    this.isCategoryOnlyView = false;
    this.categoryPaths =
      this.profiles.find((p) => p.profileName === this.selectedProfile)
        ?.categories || [];
  }

  private toCategoryOnlyView() {
    this.isCategoryOnlyView = true;
    this.categoryPaths = [];
  }

  private isSelectedProfileOutdated() {
    return (
      this.profiles.find((p) => p.profileName === this.selectedProfile)
        ?.isOutdated || false
    );
  }

  private onCategoryOnlyPathsChange(categoryPaths) {
    this.categoryPaths = categoryPaths;
  }

  async saveAndNext() {
    if (
      this.profileName === "" &&
      this.isCategoryOnlyView &&
      this.createProfileForCategories
    ) {
      this.isProfileNameInvalid = true;
      return;
    }
    this.$store.commit("startLoading");
    if (this.isCategoryOnlyView && this.createProfileForCategories) {
      await this.createProfileAndUpdateCategories();
    } else {
      await this.uploadCategories();
    }
  }

  async createProfileAndUpdateCategories() {
    this.$api
      .post(`item-classification-api/v1/profiles/${this.companyId}`, {
        categories: this.categoryPaths,
        profileName: this.profileName,
      })
      .then((response) => {
        this.selectedProfile = this.profileName;
        this.uploadCategories();
      })
      .catch((error) => {
        this.$store.commit("stopLoading");
        this.displayError(error);
      });
  }

  async uploadCategories() {
    this.$api
      .put(
        `item-classification-api/v1/jobs/${this.companyId}/${this.jobId}/categories`,
        {
          categories: this.categoryPaths,
          profileName:
            this.isCategoryOnlyView && !this.createProfileForCategories
              ? ""
              : this.selectedProfile,
        }
      )
      .then((response) => {
        this.$store.commit("stopLoading");
        this.$emit("step-done");
      })
      .catch((error) => {
        this.$store.commit("stopLoading");
        this.displayError(error);
      });
  }

  private previous() {
    (this.$parent as any).previousStep();
  }

  private cancel() {
    this.$router.push({
      path: `/classification/${this.accountId}/${this.companyId}/jobs`,
    });
  }
}
